<div class="LesitungEdit row" *ngIf="Entry && Entry != null">
  <div class="row">
    <div class="row">
      <div class="col edit">
        <AdminCard [Item]="Entry">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="bezeichnung" [(ngModel)]="Entry.bezeichnung">
                <label for="bezeichnung">Bezeichnung</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="hersteller" [(ngModel)]="Entry.hersteller">
                <label for="hersteller">Hersteller</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <select class="form-select"
                        id="geraeteTyp"
                        [(ngModel)]="Entry.geraeteTyp">

                  <option *ngFor="let item of Typen" [ngValue]="item.Key">
                    {{ item.Value }}
                  </option>
                </select>
                <label for="geraeteTyp">Typ</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="hilfsmittelnummer" [(ngModel)]="Entry.hilfsmittelnummer">
                <label for="hilfsmittelnummer">Hilfsmittelnummer</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="input-group mb-3">
                <div class="form-floating">
                  <input type="number" class="form-control" step="0.01" min="0.01" id="Preis" placeholder="0.00" [(ngModel)]="Entry.preis">
                  <label for="Preis">Preis</label>
                </div>
                <span class="input-group-text" id="basic-addon2">€</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="input-group mb-3">
                <div class="form-floating">
                  <input type="number" class="form-control" step="0.01" min="0.01" id="rate" placeholder="0.00" [ngModel]="Entry.rate" readonly disabled>
                  <label for="rate">Rate</label>
                </div>
                <span class="input-group-text" id="basic-addon1">€</span>
                <span class="input-group-text" id="basic-addon2" title="Bearbeiten" (click)="UpdatePreis()"><i class="bi bi-pen"></i></span>
                <span class="input-group-text" id="basic-addon3" title="Historie" (click)="OpenPreisHistory()"><i class="bi bi-clock-history"></i></span>
              </div>
            </div>
          </div>
        </AdminCard>
      </div>
    </div>
  </div>
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
